module.exports = __webpack_public_path__ + "static/media/2.7458b406.jpg";